export default "__VITE_ASSET__99b4e34c__"